import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  box-sizing: border-box;
  color: #0f172a;
  width: 100%;
  margin-bottom: 20px;
  padding: 0 20px;

  @media (min-width: 768px) {
    padding: 0;
  }

  @media (min-width: 1280px) {
    margin-top: 39px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;

  @media (min-width: 768px) {
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    box-shadow: 0 2px 16px rgba(15, 23, 42, 0.03);
    padding: 24px;
    max-width: 75%;
  }

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      max-width: 100%;
    }
  `}

  @media screen and (min-width: 1280px) {
    margin-left: 0;
  }
`;

const Payment = styled.div`
  font-size: 14px;
  line-height: 20px;
  position: relative;
`;
export { Container, Wrapper, Payment };
